import { isSellablePartType } from '../../utils/is-sellable-part-type.js';
import { isStockablePartType } from '../../utils/is-stockable-part-type.js';
export const PART_CREATE_IDENTITY_STEP = 1;
export const PART_CREATE_TYPE_STEP = 2;
export const PART_CREATE_UOM_STEP = 3;
/** Wizard step that collects optional product link / inline create. */
export const PART_CREATE_PRODUCT_STEP = 4;
export const PART_CREATE_LOCATION_STEP = 5;
export const PART_CREATE_VENDOR_STEP = 6;
export const PART_CREATE_COSTING_STEP = 7;
/** Review step — no field validation schema. */
export const PART_CREATE_REVIEW_STEP = 8;
const ALL_PART_CREATE_STEPS = [
    PART_CREATE_IDENTITY_STEP,
    PART_CREATE_TYPE_STEP,
    PART_CREATE_UOM_STEP,
    PART_CREATE_PRODUCT_STEP,
    PART_CREATE_LOCATION_STEP,
    PART_CREATE_VENDOR_STEP,
    PART_CREATE_COSTING_STEP,
    PART_CREATE_REVIEW_STEP,
];
export function shouldShowProductStep(typeId) {
    return Boolean(typeId) && isSellablePartType(typeId);
}
/** Location and reorder levels only make sense for a part type that occupies physical space. */
export function shouldShowLocationStep(typeId) {
    return Boolean(typeId) && isStockablePartType(typeId);
}
/**
 * The steps actually shown for this part type, in order. Navigation walks this list rather than
 * bumping past one hidden step at a time — a type that is neither sellable nor stockable hides two
 * adjacent steps, which single-hop skipping could not handle.
 */
export function getVisiblePartCreateSteps(typeId) {
    return ALL_PART_CREATE_STEPS.filter((step) => {
        if (step === PART_CREATE_PRODUCT_STEP)
            return shouldShowProductStep(typeId);
        if (step === PART_CREATE_LOCATION_STEP)
            return shouldShowLocationStep(typeId);
        return true;
    });
}
//# sourceMappingURL=create-wizard-navigation.js.map